export const COUNTRY_CODE_ROUTE_PARAM = 'countryCode';

export enum CountryCode {
  CZECH = 'CZ',
  GERMANY = 'DE',
  FRANCE = 'FR',
  SWITZERLAND = 'CH',
  ITALIA = 'IT',
  SPAIN = 'ES',
  BELGIUM = 'BE',
  FINLAND = 'FI',
  NORWAY = 'NO',
  DENMARK = 'DK',
  SWEDEN = 'SE',
  REGION = 'REGION',
}

export const EXPECTED_STOCK_OUT_COUNTRIES = [
  CountryCode.BELGIUM,
  CountryCode.FRANCE,
  CountryCode.SWITZERLAND,
  CountryCode.SWEDEN,
  CountryCode.NORWAY,
  CountryCode.DENMARK,
  CountryCode.FINLAND,
];
